import graphql from 'graphql-tag'
import client from '@stores/apollo'
import { IAssetTag } from '@api'
import { AssetTagFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateTag: {
    tag: IAssetTag
  }
}

const mutateHandler = handleFetchResult<IPayload, IAssetTag>({
  handler: (data) => data.updateTag.tag,
  name: 'Asset Tag',
})

export default function updateAssetTag(
  id: string,
  newName?: string,
  employees?: { connect?: { id: string }[]; disconnect?: { id: string }[] },
  spaces?: { connect?: { id: string }[]; disconnect?: { id: string }[] }
): Promise<IAssetTag> {
  const mutateOptions = {
    mutation,
    variables: {
      input: { where: { id }, data: { name: newName, employees, spaces } },
    },
  }
  return client.gql.mutate<IPayload>(mutateOptions).then(mutateHandler)
}

const mutation = graphql`
  mutation updateAssetTag($input: UpdateTagMutationInput!) {
    updateTag(input: $input) {
      tag {
        ...AssetTagFragment
      }
    }
  }
  ${AssetTagFragment}
`
